import { useReleaseCabinet } from '@speedlo/tools'
import React from 'react'
import { Route } from 'react-router-dom'
import { Container } from 'reactstrap'

const DevelopmentView = React.lazy(() =>
  import('../segments/development/DevelopmentView'),
)
const FeedbackView = React.lazy(() =>
  import('../segments/feedback/FeedbackView'),
)
const FinishView = React.lazy(() => import('../segments/finish/FinishView'))
const MapView = React.lazy(() => import('../segments/map/MapView'))
const ShopOverview = React.lazy(() => import('../segments/shop/ShopOverview'))

const DesktopApp = () => {
  useReleaseCabinet(alert)
  return (
    <Container fluid={true}>
      <Route exact={true} path="/" component={MapView} />
      <Route path={['/order', '/confirm']} component={ShopOverview} />
      <Route path="/finish" component={FinishView} />
      <Route path="/feedback" component={FeedbackView} />
      <Route path="/development" component={DevelopmentView} />
    </Container>
  )
}

export default DesktopApp
